export default __webpack_public_path__ + "static/1.1_IT-88bc370f1e2a97b9713675420205cf7d.png";